import { render, staticRenderFns } from "./EmployeeTerminate.vue?vue&type=template&id=51057d9a&"
import script from "./EmployeeTerminate.vue?vue&type=script&lang=js&"
export * from "./EmployeeTerminate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports